import React from 'react'

export default ({ title }) => (
  <h1>{title}</h1>
)